import React, { useState, useEffect, useCallback } from "react";

import { useNavigate } from "react-router-dom";

import { API, UPLOADS } from "./../../config/api";
import AOS from "aos";
import "aos/dist/aos.css";
import SupplierCard from "./SupplierCard";
import Adsense from "../../Admin/Pages/Adsense";
import GridRow from "./GridRow";

import Login from "./Login";
import Profile from "./Profie";
const BASE_URL = `${API.BASE_URL}/api.php`;

export default function Home() {
  const navigate = useNavigate();

  /* ================= STATES ================= */
  const [machines, setMachines] = useState([]);
  const [designers, setDesigners] = useState([]);
  const [workspace, setWorkspace] = useState([]);
  const [wishlist, setWishlist] = useState([]);
  const [selectedWork, setSelectedWork] = useState(null);
  const [priceInput, setPriceInput] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [user, setUser] = useState(null);
  const [slides, setSlides] = useState([]);
  const [works, setWorks] = useState([]);
  const [workCount, setWorkCount] = useState(0);
  const [designs, setDesigns] = useState([]);
  const [lightboxData, setLightboxData] = useState(null);
  const [suppliers, setSuppliers] = useState([]);
  const [paiddesigns, setPaidDesigns] = useState([]);
  const [cartIds, setCartIds] = useState([]);
  const [wishlistIds, setWishlistIds] = useState([]);
  const [showAdModal, setShowAdModal] = useState(false);
  const [adTimer, setAdTimer] = useState(5);
  const [pendingDownloadUrl, setPendingDownloadUrl] = useState(null);
  const [downloaded, setDownloaded] = useState({});
  const [currentSlide, setCurrentSlide] = useState(0);
  const [imageIndexes1, setImageIndexes1] = useState({});
  const [paidDesignCount, setPaidDesignCount] = useState(0);
  const [machineCount, setMachineCount] = useState(0);
  const [designerCount, setDesignerCount] = useState(0);
  const [sketcherCount, setSketcherCount] = useState(0);
  const [freeDesignRowCount, setFreeDesignRowCount] = useState(0);
  const [workspaceRowCount, setWorkspaceRowCount] = useState(0);
  const [supplierRowCounts, setSupplierRowCounts] = useState({});
  const [commission, setCommission] = useState(0);
  const [sketchers, setSketchers] = useState([]);
  const [selectedDescription, setSelectedDescription] = useState("");
  const [showDescriptionModal, setShowDescriptionModal] = useState(false);
  const UPLOAD_URL = `${API.BASE_URL}/uploads/work`;
  const getCommission = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}?action=get_platform_bid_commission`,
      );

      const result = await response.json();

      if (result.status) {
        setCommission(Number(result.commission));
      }
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    getCommission();
  }, []);
  const groupedSuppliers = suppliers.reduce((acc, item) => {
    if (!acc[item.supplier_table]) {
      acc[item.supplier_table] = [];
    }

    acc[item.supplier_table].push(item);

    return acc;
  }, {});
  const bidPrice = Number(priceInput || 0);

  const commissionAmount = (bidPrice * commission) / 100;

  const finalAmount = bidPrice - commissionAmount;
  const nextImage1 = (e, item, images) => {
    e.stopPropagation();

    const current = imageIndexes1[item.id] || 0;

    if (current >= images.length - 1) {
      navigate(`/houserentdetails/${item.id}`);
      return;
    }

    setImageIndexes1((prev) => ({
      ...prev,
      [item.id]: current + 1,
    }));
  };
  const openDescriptionModal = (description) => {
    setSelectedDescription(description);
    setShowDescriptionModal(true);
  };
  const prevImage1 = (e, item) => {
    e.stopPropagation();

    const current = imageIndexes1[item.id] || 0;

    if (current === 0) return;

    setImageIndexes1((prev) => ({
      ...prev,
      [item.id]: current - 1,
    }));
  };
  const [popupData, setPopupData] = useState({
    open: false,
    images: [],
    index: 0,
    userId: null,
    folder: "",
  });
  const openLightbox = (imagesArray, initialIndex, ownerId) => {
    const fullUrls = imagesArray.map(
      (img) => `${UPLOAD_URL}/${ownerId}/${img}`,
    );
    setLightboxData({
      images: fullUrls,
      currentIndex: initialIndex,
    });
  };

  const handlePrevImage = useCallback(() => {
    if (!lightboxData) return;
    setLightboxData((prev) => ({
      ...prev,
      currentIndex:
        prev.currentIndex === 0
          ? prev.images.length - 1
          : prev.currentIndex - 1,
    }));
  }, [lightboxData]);

  const handleNextImage = useCallback(() => {
    if (!lightboxData) return;
    setLightboxData((prev) => ({
      ...prev,
      currentIndex:
        prev.currentIndex === prev.images.length - 1
          ? 0
          : prev.currentIndex + 1,
    }));
  }, [lightboxData]);

  // Keyboard navigation for Lightbox (Arrow Keys & Escape)
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!lightboxData) return;
      if (e.key === "ArrowLeft") handlePrevImage();
      if (e.key === "ArrowRight") handleNextImage();
      if (e.key === "Escape") setLightboxData(null);
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [lightboxData, handlePrevImage, handleNextImage]);

  // ==========================
  // OPEN PRICE MODAL
  // ==========================
  // const handleOpenAddBeads = (work) => {
  //   if (!user) {
  //     alert("Please login first.");
  //     navigate("/login");
  //     return;
  //   }
  //   setSelectedWork(work);
  //   setPriceInput("");
  // };
  const handleOpenAddBeads = (work) => {
    const loginUser = JSON.parse(sessionStorage.getItem("user"));

    // Not logged in
    if (!loginUser) {
      alert("Please login first.");
      setShowLogin(true);
      return;
    }

    const providerOptions = loginUser.provider_options || "";

    const isDesigner = Array.isArray(providerOptions)
      ? providerOptions.some(
          (item) => item.toLowerCase().trim() === "designers",
        )
      : providerOptions
          .toLowerCase()
          .split(",")
          .map((v) => v.trim())
          .includes("designers");

    // Logged in but not designer
    if (!isDesigner) {
      alert(
        "Only Designer accounts can add bids.\n\nPlease enable the Designer option from your profile.",
      );

      // optional
      setShowProfile(true);

      return;
    }

    // Allowed
    setSelectedWork(work);
    setPriceInput("");
  };
  // ==========================
  // SUBMIT BEADS
  // ==========================
  const handleConfirmAddBeads = async (e) => {
    e.preventDefault();

    if (!priceInput.trim() || isNaN(priceInput) || Number(priceInput) <= 0) {
      alert("Please enter a valid positive price.");
      return;
    }

    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("user_id", user.id);
    formData.append("work_id", selectedWork.id);
    formData.append("price", priceInput);

    try {
      const response = await fetch(`${BASE_URL}?action=add_beads_from_work`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();
      alert(result.message);

      if (result.status) {
        setSelectedWork(null);
        navigate("/user/myBids");
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const openImagePopup = (img, userId, images, folder) => {
    if (!Array.isArray(images)) return;

    const index = images.findIndex((i) => i === img);

    setPopupData({
      open: true,
      images,
      index: index >= 0 ? index : 0,
      userId,
      folder,
    });
  };

  useEffect(() => {
    if (!popupData.open) return;

    const handleKeyDown = (e) => {
      if (e.key === "ArrowRight") {
        setPopupData((prev) => ({
          ...prev,
          index:
            prev.index < prev.images.length - 1 ? prev.index + 1 : prev.index,
        }));
      }

      if (e.key === "ArrowLeft") {
        setPopupData((prev) => ({
          ...prev,
          index: prev.index > 0 ? prev.index - 1 : prev.index,
        }));
      }

      if (e.key === "Escape") {
        setPopupData((prev) => ({ ...prev, open: false }));
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [popupData.open]);
  const handleLocationRedirect = (address) => {
    if (!address) return;
    const mapUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
    window.open(mapUrl, "_blank", "noopener,noreferrer");
  };

  const [imageIndexes, setImageIndexes] = useState({});
  const nextImage = (e, item, images) => {
    e.stopPropagation();

    const current = imageIndexes[item.id] || 0;

    if (current >= images.length - 1) {
      navigate(`/productdetails/${item.id}`);
      return;
    }

    setImageIndexes((prev) => ({
      ...prev,
      [item.id]: current + 1,
    }));
  };

  const prevImage = (e, item) => {
    e.stopPropagation();

    const current = imageIndexes[item.id] || 0;

    if (current === 0) return;

    setImageIndexes((prev) => ({
      ...prev,
      [item.id]: current - 1,
    }));
  };
  const [slideDelay, setSlideDelay] = useState(10000); // default 10 sec
  useEffect(() => {
    let interval;

    if (showAdModal && adTimer > 0) {
      interval = setInterval(() => {
        setAdTimer((prev) => prev - 1);
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [showAdModal, adTimer]);
  const handleFreeDesignDownload = (design) => {
    const loginUser = JSON.parse(sessionStorage.getItem("user"));

    // User not logged in
    if (!loginUser) {
      setShowLogin(true);
      return;
    }

    // User logged in
    triggerDownload(
      design.emb_file,
      design.category,
      design.design_code,
      design.id,
    );
  };
  const triggerDownload = (file, category, code, id) => {
    const url = `${API.DOWNLOAD}&file=FreeDesigns/${file}`;

    setPendingDownloadUrl({
      url,
      code,
      id,
    });

    setAdTimer(5);
    setShowAdModal(true);
  };
  const addToCart = (design) => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    if (!user) return alert("Please Login First");

    let items = JSON.parse(localStorage.getItem(`cart_${user.id}`)) || [];
    const exists = items.find((i) => i.id === design.id && i.type === "design");

    if (exists) {
      items = items.filter((i) => !(i.id === design.id && i.type === "design"));
      setCartIds((prev) => prev.filter((id) => id !== design.id));
    } else {
      items.push({ ...design, type: "design" });
      setCartIds((prev) => [...prev, design.id]);
    }

    localStorage.setItem(`cart_${user.id}`, JSON.stringify(items));
    window.dispatchEvent(new Event("cartUpdated"));
  };
  const addToWishlist = (design) => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    if (!user) return;

    let items = JSON.parse(localStorage.getItem(`wishlist_${user.id}`)) || [];
    const exists = items.find((i) => i.id === design.id && i.type === "design");

    if (exists) {
      items = items.filter((i) => !(i.id === design.id && i.type === "design"));
      setWishlistIds((prev) => prev.filter((id) => id !== design.id));
    } else {
      items.push({ ...design, type: "design" });
      setWishlistIds((prev) => [...prev, design.id]);
    }

    localStorage.setItem(`wishlist_${user.id}`, JSON.stringify(items));
    window.dispatchEvent(new Event("cartUpdated"));
  };
  const fetchAllData = useCallback(async () => {
    const timestamp = new Date().getTime();

    try {
      // Machines
      const resM = await fetch(`${API.LIST_ACTIVE_MACHINES}&t=${timestamp}`);
      const dataM = await resM.json();
      setMachines(Array.isArray(dataM) ? dataM : dataM.data || []);

      // Designers
      // Designers only
      const resD = await fetch(
        `${API.LIST_ACTIVE_DESIGNERS}&profile_type=designer&t=${timestamp}`,
      );

      const dataD = await resD.json();

      setDesigners(Array.isArray(dataD) ? dataD : dataD.data || []);
      // Sketchers
      const resS = await fetch(
        `${API.LIST_ACTIVE_DESIGNERS}&profile_type=sketcher&t=${timestamp}`,
      );

      const dataS = await resS.json();

      setSketchers(Array.isArray(dataS) ? dataS : dataS.data || []);

      // Workspaces
      const resW = await fetch(`${API.LIST_ACTIVE_WORKSPACES}&t=${timestamp}`);
      const dataW = await resW.json();
      setWorkspace(Array.isArray(dataW) ? dataW : dataW.data || []);
      // Active Works
      const resWork = await fetch(
        `${API.BASE_URL}/api.php?action=get_all_works_Active&t=${timestamp}`,
      );
      const dataWork = await resWork.json();

      if (dataWork.status) {
        setWorks(dataWork.data || []);
      } else {
        setWorks([]);
      }
      // Designs
      const resDesign = await fetch(`${API.LIST_DESIGNS}&t=${timestamp}`);
      const dataDesign = await resDesign.json();
      setDesigns(dataDesign.data || []);
      const res = await fetch(`${API.BASE_URL}/api.php?action=all_suppliers`);

      const data = await res.json();

      if (data.status) {
        setSuppliers(data.data);
      }
      // paid designs
      const respaidDesign = await fetch(
        `${API.LIST_DESIGNS_user}&t=${timestamp}`,
      );

      const datapaidDesign = await respaidDesign.json();

      setPaidDesigns(datapaidDesign.data || []);

      // supplier

      // beads
    } catch (error) {
      console.log("Fetch Error:", error);
    }
  }, []);

  useEffect(() => {
    fetchAllData();
    const interval = setInterval(fetchAllData, 5000);
    window.addEventListener("focus", fetchAllData);

    return () => {
      clearInterval(interval);
      window.removeEventListener("focus", fetchAllData);
    };
  }, [fetchAllData]);
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-in-out",
      once: true,
      offset: 100,
    });
  }, []);
  useEffect(() => {
    AOS.refresh();
  }, [machines, designers, workspace, designs]);

  /* ================= WISHLIST LOGIC ================= */
  const loadUserAndWishlist = useCallback(() => {
    const loginUser = JSON.parse(sessionStorage.getItem("user"));
    setUser(loginUser);
    if (loginUser) {
      const saved =
        JSON.parse(localStorage.getItem(`wishlist_${loginUser.id}`)) || [];
      setWishlist(saved);
    } else {
      setWishlist([]);
    }
  }, []);

  useEffect(() => {
    loadUserAndWishlist();
    window.addEventListener("wishlistUpdate", loadUserAndWishlist);
    window.addEventListener("storage", loadUserAndWishlist);
    return () => {
      window.removeEventListener("wishlistUpdate", loadUserAndWishlist);
      window.removeEventListener("storage", loadUserAndWishlist);
    };
  }, [loadUserAndWishlist]);

  useEffect(() => {
    loadUserAndWishlist();

    window.addEventListener("cartUpdated", loadUserAndWishlist);
    window.addEventListener("storage", loadUserAndWishlist);

    return () => {
      window.removeEventListener("cartUpdated", loadUserAndWishlist);
      window.removeEventListener("storage", loadUserAndWishlist);
    };
  }, [loadUserAndWishlist]);
  const isLiked = (id, type) =>
    wishlist.some((w) => w.id === id && w.type === type);

  const loadSlider = async () => {
    try {
      const res = await fetch(API.GET_HERO_SLIDER);
      const data = await res.json();

      if (data.status) {
        setSlides(data.data);
      }
    } catch (err) {
      console.log("Slider Error:", err);
    }
  };

  useEffect(() => {
    loadSlider();
  }, []);

  useEffect(() => {
    if (slides.length === 0) return;

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);

      // After auto-changing, go back to 10 sec
      setSlideDelay(10000);
    }, slideDelay);

    return () => clearInterval(interval);
  }, [slides.length, slideDelay, currentSlide]);

  // Handle manual slide selection
  const handleDotClick = (index) => {
    setCurrentSlide(index);

    // Keep clicked slide visible for 20 sec
    setSlideDelay(15000);
  };

  const toggleWishlist = (item, type) => {
    if (!user) {
      alert("Please login first");
      return;
    }
    const storageKey = `wishlist_${user.id}`;
    let updated = JSON.parse(localStorage.getItem(storageKey)) || [];

    const exists = updated.find((i) => i.id === item.id && i.type === type);
    if (exists) {
      updated = updated.filter((i) => !(i.id === item.id && i.type === type));
    } else {
      updated.push({ ...item, type: type });
    }

    localStorage.setItem(storageKey, JSON.stringify(updated));
    setWishlist(updated);

    // 🔥 CHANGE THIS: Notify Navbar and other pages using the universal name
    window.dispatchEvent(new Event("cartUpdated"));
  };
  useEffect(() => {
    if (!showAdModal) return;
    if (adTimer <= 0) return;

    const interval = setInterval(() => {
      setAdTimer((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [showAdModal, adTimer]);
  const openWorkDetails = (work) => {
    navigate("/work-details", {
      state: {
        work,
      },
    });
  };
  const DESIGN_TYPES = ["Multi", "Sequence", "Cording", "Beads"];

  const getWorkDescriptionData = (description = "") => {
    if (!description) {
      return {
        designTypes: [],
        extraDescription: "",
      };
    }

    const parts = description
      .split(/,|\n/)
      .map((item) => item.trim())
      .filter(Boolean);

    const selectedTypes = [];
    const extraParts = [];

    parts.forEach((part) => {
      const matchedType = DESIGN_TYPES.find(
        (type) => type.toLowerCase() === part.toLowerCase(),
      );

      if (matchedType) {
        selectedTypes.push(matchedType);
      } else {
        extraParts.push(part);
      }
    });

    return {
      designTypes: selectedTypes,
      extraDescription: extraParts.join(", "),
    };
  };
  return (
    <>
      <div className="hero-slider" data-aos="zoom-in">
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`hero-slide ${index === currentSlide ? "active" : ""}`}
            style={{
              backgroundImage: `url(${UPLOADS.SLIDER_IMAGE}${slide.image})`,
            }}
          />
        ))}

        <div className="hero-dots">
          {slides.map((_, i) => (
            <span
              key={i}
              className={i === currentSlide ? "active-dot" : ""}
              onClick={() => handleDotClick(i)}
            />
          ))}
        </div>
      </div>

      <div className="home-page container-fluid ">
        <div className="row g-4">
          <div className="col-lg-12 col-md-8 col-12">
            <div className="sm-about-wrapper"></div>

            <div className="container-section mb-0">
              <h2 className="section-title mb-0" data-aos="fade-right">
                Free New Designs
              </h2>

              <GridRow
                items={designs}
                onCountChange={setFreeDesignRowCount}
                renderCard={(design) => (
                  <div
                    className="design-card"
                    key={design.id}
                    onClick={() =>
                      navigate(`/designe-details/${design.id}`, {
                        state: design,
                      })
                    }
                    data-aos="zoom-in-up"
                  >
                    <div className="image-wrapper">
                      <img
                        src={`${UPLOADS.DESIGN_IMAGE}FreeDesigns/${design.jpeg_file}`}
                        alt={design.design_code}
                      />
                    </div>

                    <div className="card-body">
                      <div className="design-specs">
                        <div className="spec-left">
                          <div>
                            <strong>Stitch:</strong> {design.stitch}
                          </div>
                          <div>
                            <strong>Colour:</strong> {design.color}
                          </div>
                        </div>

                        <div className="spec-right">
                          <div>
                            <strong>Area:</strong> {design.area}
                          </div>
                          <div>
                            <strong>Code:</strong> {design.design_code}
                          </div>
                        </div>
                      </div>

                      <h5 className="price-tag-row text-center">₹ 0</h5>

                      <div className="card-action-row">
                        <div className="action-btns">
                          {downloaded[design.id] ? (
                            <button className="btn btn-teal1 btn-sm w-100">
                              <i className="bi bi-check-circle-fill me-1"></i>
                              Downloaded
                            </button>
                          ) : (
                            <button
                              className="btn btn-teal btn-sm w-100"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleFreeDesignDownload(design);
                              }}
                            >
                              <i className="bi bi-download me-1"></i>
                              Download
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              />
              {designs.length > freeDesignRowCount && (
                <div className="text-center mt-4">
                  <button
                    className="view-more-btn"
                    onClick={() => navigate("/designs")}
                  >
                    View More Designs
                    <i className="bi bi-arrow-right ms-2"></i>
                  </button>
                </div>
              )}
            </div>

            <div className="container-section mb-0">
              <h2 className="section-title mb-0" data-aos="fade-right">
                Buy New Designs
              </h2>

              <GridRow
                items={paiddesigns}
                renderCard={(paiddesign) => (
                  <div
                    className="design-card"
                    key={paiddesign.id}
                    data-aos="zoom-in-up"
                    onClick={() =>
                      navigate(`/design-details/${paiddesign.id}`, {
                        state: paiddesign,
                      })
                    }
                  >
                    <div className="image-wrapper">
                      <img
                        src={`${API.BASE_URL}/uploads/Design_seller/${paiddesign.user_id}/${paiddesign.jpeg_file}`}
                        alt={paiddesign.design_code}
                      />
                    </div>
                    <div className="card-body">
                      <div className="design-specs">
                        <div className="spec-left">
                          <div>
                            <strong className="strong1">Code:</strong>{" "}
                            {paiddesign.design_code}
                          </div>
                          <div>
                            <strong className="strong1">Stitch:</strong>{" "}
                            {paiddesign.stitch}
                          </div>
                        </div>
                        <div className="spec-right text-start">
                          <div>
                            <strong className="strong1">Area:</strong>{" "}
                            {paiddesign.area}
                          </div>
                          <div>
                            <strong className="strong1">Color:</strong>{" "}
                            {paiddesign.color}
                          </div>
                        </div>
                      </div>

                      <h5 className="price-tag-row text-center mt-2">
                        ₹ {paiddesign.price}
                      </h5>
                      <div className="card-action-row">
                        <div className="action-btns">
                          <button
                            className={`select-btn ${cartIds.includes(paiddesign.id) ? "selected-btn" : ""}`}
                            onClick={(e) => {
                              e.stopPropagation();
                              addToCart(paiddesign);
                            }}
                          >
                            <i
                              className={`bi ${cartIds.includes(paiddesign.id) ? "bi-cart-check-fill" : "bi-cart-fill"} me-1`}
                            ></i>
                            {cartIds.includes(paiddesign.id)
                              ? "SELECTED"
                              : "SELECT"}
                          </button>
                          <button
                            className="wish-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              addToWishlist(paiddesign);
                            }}
                          >
                            <i
                              className={`bi ${wishlistIds.includes(paiddesign.id) ? "bi-heart-fill text-danger" : "bi-heart"}`}
                            ></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              />
              {paiddesigns.length > paidDesignCount && (
                <div className="text-center mt-4">
                  <button
                    className="view-more-btn"
                    onClick={() =>
                      navigate("/designs", {
                        state: { activeTab: "paid" },
                      })
                    }
                  >
                    View More Designs
                    <i className="bi bi-arrow-right ms-2"></i>
                  </button>
                </div>
              )}
            </div>
            <div className="container-section mb-0">
              <h2 className="section-title mb-0" data-aos="fade-right">
                Embroidery Work
              </h2>

              <GridRow
                items={works}
                onCountChange={setWorkCount}
                renderCard={(item) => {
                  const { designTypes, extraDescription } =
                    getWorkDescriptionData(item.description);

                  return (
                    <div
                      className="eb-work-card"
                      key={item.id}
                      onClick={() => openWorkDetails(item)}
                      style={{ cursor: "pointer" }}
                    >
                      {/* Carousel Header */}
                      <div className="eb-card-media">
                        <div
                          id={`carousel${item.id}`}
                          className="carousel slide h-100"
                          data-bs-ride="carousel"
                        >
                          <div className="carousel-inner h-100">
                            {item.images && item.images.length > 0 ? (
                              item.images.map((img, index) => {
                                const imgSrc = `${UPLOAD_URL}/${item.owner_id}/${img}`;
                                return (
                                  <div
                                    key={index}
                                    className={`carousel-item h-100 ${
                                      index === 0 ? "active" : ""
                                    }`}
                                  >
                                    <img
                                      src={imgSrc}
                                      className="eb-card-img"
                                      alt={`Work ${item.id} preview ${index + 1}`}
                                      onClick={() =>
                                        openLightbox(
                                          item.images,
                                          index,
                                          item.owner_id,
                                        )
                                      }
                                      title="Click to expand view"
                                    />
                                    {item.images.length > 1 && (
                                      <div className="eb-image-count-overlay">
                                        <i className="bi bi-images"></i>
                                        <span>+{item.images.length}</span>
                                      </div>
                                    )}
                                  </div>
                                );
                              })
                            ) : (
                              <div className="eb-no-image">
                                <i className="bi bi-image"></i>
                                <span>No image available</span>
                              </div>
                            )}
                          </div>

                          {/* {item.images && item.images.length > 1 && (
                          <>
                            <button
                              className="carousel-control-prev eb-carousel-btn"
                              type="button"
                              data-bs-target={`#carousel${item.id}`}
                              data-bs-slide="prev"
                            >
                              <span className="carousel-control-prev-icon"></span>
                            </button>

                            <button
                              className="carousel-control-next eb-carousel-btn"
                              type="button"
                              data-bs-target={`#carousel${item.id}`}
                              data-bs-slide="next"
                            >
                              <span className="carousel-control-next-icon"></span>
                            </button>
                          </>
                        )} */}
                        </div>
                      </div>

                      {/* Card Body */}
                      <div className="eb-card-body">
                        <div className="eb-card-date">
                          <i className="bi bi-calendar-event me-2"></i>

                          {item.created_at
                            ? new Date(item.created_at).toLocaleDateString(
                                "en-GB",
                                {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                },
                              )
                            : "-"}
                        </div>

                        {/* DESIGN TYPE */}
                        {designTypes.length > 0 && (
                          <div className="eb-design-type-list">
                            {designTypes.map((type) => (
                              <span
                                key={type}
                                className={`eb-design-type-badge eb-design-type-${type
                                  .toLowerCase()
                                  .replace(/\s/g, "")}`}
                              >
                                <i className="bi bi-check-circle-fill"></i>
                                {type}
                              </span>
                            ))}
                          </div>
                        )}

                        {/* EXTRA DESCRIPTION */}
                        {/* {extraDescription && (
                          <p className="eb-work-extra-description">
                            {extraDescription}
                          </p>
                        )} */}

                        <div className="eb-work-card-actions mt-2">
                          <button
                            type="button"
                            className="eb-work-card-add-bid"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleOpenAddBeads(item);
                            }}
                          >
                            <i className="bi bi-plus-circle-fill"></i>
                            <span>Add Bids</span>
                          </button>
                          <button
                            type="button"
                            className="eb-work-card-view-icon"
                            onClick={(e) => {
                              e.stopPropagation();
                              openWorkDetails(item);
                            }}
                            title="View Work"
                          >
                            <i className="bi bi-eye-fill"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                }}
              />
              {works.length > workCount && (
                <div className="text-center mt-4">
                  <button
                    className="view-more-btn"
                    onClick={() => navigate("/Work-list")}
                  >
                    View More Works
                    <i className="bi bi-arrow-right ms-2"></i>
                  </button>
                </div>
              )}
            </div>
            <div className="container-section mb-0">
              <h2 className="section-title mb-0">Featured Machines</h2>

              <GridRow
                items={machines}
                onCountChange={setMachineCount}
                renderCard={(item) => {
                  const images = item.image ? item.image.split(",") : [];

                  return (
                    <div
                      className="design-card"
                      key={item.id}
                      onClick={() => navigate(`/productdetails/${item.id}`)}
                      style={{ cursor: "pointer" }}
                      data-aos="zoom-in-up"
                    >
                      <div
                        className="machine-img-container"
                        onClick={() => navigate(`/productdetails/${item.id}`)}
                      >
                        <img
                          src={`${UPLOADS.MACHINE_IMAGE}${item.user_id}/${
                            images[imageIndexes[item.id] || 0]
                          }?t=${Date.now()}`}
                          alt={item.machine_name}
                        />
                        {images.length > 1 && (
                          <>
                            {(imageIndexes[item.id] || 0) > 0 && (
                              <button
                                className="img-arrow left-arrow"
                                onClick={(e) => prevImage(e, item)}
                              >
                                <i className="bi bi-chevron-left"></i>
                              </button>
                            )}

                            <button
                              className="img-arrow right-arrow"
                              onClick={(e) => nextImage(e, item, images)}
                            >
                              <i className="bi bi-chevron-right"></i>
                            </button>
                          </>
                        )}
                        {images.length > 1 && (
                          <div className="image-count">
                            <i className="bi bi-images me-1"></i>+
                            {images.length - 1}
                          </div>
                        )}
                        <span className="heads-badge">
                          {item.NoOfHeads} Heads
                        </span>
                      </div>
                      <div className="machine-body">
                        <div className="machine-type">
                          <h4 className="machine-name">{item.machine_name}</h4>
                        </div>
                        <div className="d-flex align-items-center justify-content-between mt-2">
                          <div className="price-block">
                            <span className="currency-symbol">₹</span>
                            <span className="amount">
                              {Number(item.price).toLocaleString("en-IN")}
                            </span>
                          </div>
                        </div>
                        <div className="spec-row mt-2 mb-0">
                          <div className="spec-item">
                            <span className="spec-label">Brand:</span>
                            <span className="spec-value">{item.brand}</span>
                          </div>
                          <div className="spec-item">
                            <span className="spec-label">Area:</span>
                            <span className="spec-value">{item.Area}</span>
                          </div>
                        </div>
                        <div className="spec-item mt-0 p-1">
                          <span className="spec-label1">
                            {" "}
                            <i className="bi bi-person-fill me-2"></i>
                            {item.name}
                          </span>
                        </div>
                        <div className="location-info mb-0 p-1">
                          <i className="bi bi-geo-alt-fill"></i> {item.city},{" "}
                          {item.state}
                        </div>

                        <div className="machine-footer mt-0">
                          <button
                            className="more-details-btn"
                            onClick={(e) => {
                              e.stopPropagation();

                              navigate(`/productdetails/${item.id}`, {
                                state: {
                                  activeTab: "seller",
                                },
                              });
                            }}
                          >
                            <i className="bi bi-telephone-fill me-1"></i>
                            Contact Supplier
                          </button>
                          <button
                            className="footer-like-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleWishlist(item, "machine");
                            }}
                          >
                            <i
                              className={`bi ${isLiked(item.id, "machine") ? "bi-heart-fill text-danger" : "bi-heart"}`}
                            ></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                }}
              />
              {machines.length > machineCount && (
                <div className="text-center mt-4">
                  <button
                    className="view-more-btn"
                    onClick={() => navigate("/machine")}
                  >
                    View More Machines
                    <i className="bi bi-arrow-right ms-2"></i>
                  </button>
                </div>
              )}
            </div>

            <div className="container-section mb-0">
              <h2 className="section-title mb-0">Expert Designers</h2>
              <GridRow
                items={designers}
                onCountChange={setDesignerCount}
                renderCard={(item) => (
                  <div
                    className="design-card"
                    key={item.id}
                    onClick={() =>
                      navigate(`/designerdetails/${item.id}`, {
                        state: {
                          profileType: item.profile_type,
                        },
                      })
                    }
                    style={{ cursor: "pointer" }}
                    data-aos="zoom-in-up"
                  >
                    <div className="machine-img-container">
                      <img
                        src={`${UPLOADS.DESIGNER_IMAGE}${item.profile}`}
                        className="designer-img"
                        alt={item.name}
                        style={{
                          height: "100%",
                          objectFit: "cover",
                          width: "100%",
                        }}
                      />
                    </div>
                    <div className="machine-body">
                      <h4 className="machine-name">{item.name}</h4>
                      <div className="d-flex align-items-center justify-content-between mt-2">
                        <div className="price-block">
                          <span className="currency-symbol">₹</span>
                          <span className="amount">{item.expected_salary}</span>
                          <span className="text-muted small"> / hr</span>
                        </div>
                      </div>
                      <div className="spec-row mt-0 mb-0">
                        <div className="spec-item">
                          <span className="spec-label">Skills:</span>
                          <span className="spec-value">{item.skills}</span>
                        </div>

                        <div className="spec-item">
                          <span className="spec-label">Exp:</span>
                          <span className="spec-value">{item.experience}</span>
                        </div>
                      </div>
                      <div className="location-info mt-1">
                        <i className="bi bi-geo-alt-fill text-secondary me-1"></i>{" "}
                        {item.location}
                      </div>
                      <div className="machine-footer mt-1">
                        <button
                          className="more-details-btn"
                          onClick={(e) => {
                            e.stopPropagation();

                            navigate(`/designerdetails/${item.id}`, {
                              state: {
                                activeTab: "contact",
                                profileType: item.profile_type,
                              },
                            });
                          }}
                        >
                          <i className="bi bi-person-badge-fill me-2"></i> Hire
                          Now
                        </button>

                        <button
                          className="footer-like-btn"
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleWishlist(item, "designer");
                          }}
                        >
                          <i
                            className={`bi ${isLiked(item.id, "designer") ? "bi-heart-fill text-danger" : "bi-heart"}`}
                          ></i>
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              />

              {designers.length > designerCount && (
                <div className="text-center mt-4">
                  <button
                    className="view-more-btn"
                    onClick={() => navigate("/designer")}
                  >
                    View More Designers
                    <i className="bi bi-arrow-right ms-2"></i>
                  </button>
                </div>
              )}
            </div>
            <div className="container-section mb-0">
              <h2 className="section-title mb-0">Expert Sketchers</h2>

              <GridRow
                items={sketchers}
                onCountChange={setSketcherCount}
                renderCard={(item) => (
                  <div
                    className="design-card"
                    key={item.id}
                    onClick={() =>
                      navigate(`/designerdetails/${item.id}`, {
                        state: {
                          profileType: item.profile_type,
                        },
                      })
                    }
                    style={{ cursor: "pointer" }}
                    data-aos="zoom-in-up"
                  >
                    <div className="machine-img-container">
                      <img
                        src={`${UPLOADS.DESIGNER_IMAGE}${item.profile}`}
                        className="designer-img"
                        alt={item.name}
                        style={{
                          height: "100%",
                          objectFit: "cover",
                          width: "100%",
                        }}
                      />
                      {/* <span className="heads-badge">{item.experience} Exp</span> */}
                    </div>
                    <div className="machine-body">
                      <h4 className="machine-name">{item.name}</h4>
                      <div className="d-flex align-items-center justify-content-between mt-2">
                        <div className="price-block">
                          <span className="currency-symbol">₹</span>
                          <span className="amount">{item.expected_salary}</span>
                          <span className="text-muted small"> / hr</span>
                        </div>
                      </div>
                      <div className="spec-row mt-0 mb-0">
                        <div className="spec-item">
                          <span className="spec-label">Skills:</span>
                          <span className="spec-value">{item.skills}</span>
                        </div>

                        <div className="spec-item">
                          <span className="spec-label">Exp:</span>
                          <span className="spec-value">{item.experience}</span>
                        </div>
                      </div>
                      <div className="location-info mt-1">
                        <i className="bi bi-geo-alt-fill text-secondary me-1"></i>{" "}
                        {item.location}
                      </div>
                      <div className="machine-footer mt-1">
                        <button
                          className="more-details-btn"
                          onClick={(e) => {
                            e.stopPropagation();

                            navigate(`/designerdetails/${item.id}`, {
                              state: {
                                activeTab: "contact",
                                profileType: item.profile_type,
                              },
                            });
                          }}
                        >
                          <i className="bi bi-person-badge-fill me-2"></i> Hire
                          Now
                        </button>

                        <button
                          className="footer-like-btn"
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleWishlist(item, "designer");
                          }}
                        >
                          <i
                            className={`bi ${isLiked(item.id, "designer") ? "bi-heart-fill text-danger" : "bi-heart"}`}
                          ></i>
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              />
              {sketchers.length > sketcherCount && (
                <div className="text-center mt-4">
                  <button
                    className="view-more-btn"
                    onClick={() => navigate("/designer")}
                  >
                    View More Sketchers
                    <i className="bi bi-arrow-right ms-2"></i>
                  </button>
                </div>
              )}
            </div>

            {/* FEATURED WORKSPACES */}
            <div className="container-section mb-0">
              <h2 className="section-title mb-0">Workspaces</h2>
              <GridRow
                items={workspace}
                onCountChange={setWorkspaceRowCount}
                renderCard={(item) => {
                  const images = item.image ? item.image.split(",") : [];
                  return (
                    <div
                      className="design-card"
                      key={item.id}
                      onClick={() => navigate(`/houserentdetails/${item.id}`)}
                      style={{ cursor: "pointer" }}
                      data-aos="zoom-in-up"
                    >
                      <div className="machine-img-container">
                        <img
                          src={`${UPLOADS.WORKSPACE_IMAGE}${images[imageIndexes1[item.id] || 0]}`}
                          alt="workroom"
                        />
                        {images.length > 1 && (
                          <>
                            {(imageIndexes1[item.id] || 0) > 0 && (
                              <button
                                className="img-arrow left-arrow"
                                onClick={(e) => prevImage1(e, item)}
                              >
                                <i className="bi bi-chevron-left"></i>
                              </button>
                            )}

                            <button
                              className="img-arrow right-arrow"
                              onClick={(e) => nextImage1(e, item, images)}
                            >
                              <i className="bi bi-chevron-right"></i>
                            </button>
                          </>
                        )}
                        {images.length > 1 && (
                          <div className="image-count">
                            <i className="bi bi-images me-1"></i>+
                            {images.length - 1}
                          </div>
                        )}
                        {/* <span className="heads-badge">{item.floor} </span> */}
                      </div>

                      <div className="machine-body">
                        <h4 className="machine-name">{item.location}</h4>
                        <div className="d-flex align-items-center justify-content-between mt-2">
                          <div className="price-block">
                            <span className="currency-symbol">₹</span>
                            <span className="amount">
                              {parseInt(item.rent_price).toLocaleString(
                                "en-IN",
                              )}
                            </span>
                            <span className="rent-unit"> </span>
                          </div>
                        </div>

                        <div className="spec-row mt-0 mb-0">
                          <div className="spec-item">
                            <span className="spec-label">Size:</span>
                            <span className="spec-value"> {item.size} </span>
                          </div>
                          <div className="spec-item">
                            <span className="spec-label">Floor:</span>
                            <span className="spec-value"> {item.floor}</span>
                          </div>
                        </div>

                        <div className="location-info">
                          <i className="bi bi-geo-alt-fill"></i>
                          {item.city},{item.state}
                        </div>

                        <div className="machine-footer mt-1">
                          <button
                            className="more-details-btn"
                            onClick={(e) => {
                              e.stopPropagation();

                              navigate(`/houserentDetails/${item.id}`, {
                                state: {
                                  activeTab: "ownerInfo",
                                },
                              });
                            }}
                          >
                            <i className="bi bi-telephone-fill me-1"></i>{" "}
                            Contact Owner
                          </button>

                          <button
                            className="footer-like-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleWishlist(item, "house");
                            }}
                          >
                            <i
                              className={`bi ${isLiked(item.id, "house") ? "bi-heart-fill text-danger" : "bi-heart"}`}
                            ></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                }}
              />
              {workspace.length > workspaceRowCount && (
                <div className="text-center mt-4">
                  <button
                    className="view-more-btn"
                    onClick={() => navigate("/house")}
                  >
                    View More Workplace
                    <i className="bi bi-arrow-right ms-2"></i>
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* {Object.entries(groupedSuppliers).map(([table, items]) => (
        <div className="container-section mb-5" key={table}>
          <h2 className="section-title mb-0 text-capitalize">{table}</h2>

          <GridRow
            items={items}
            onCountChange={(count) =>
              setSupplierRowCounts((prev) => ({
                ...prev,
                [table]: count,
              }))
            }
            renderCard={(item) => (
              <SupplierCard
                key={item.id}
                item={item}
                openImagePopup={openImagePopup}
                handleLocationRedirect={handleLocationRedirect}
              />
            )}
          />

          {items.length > (supplierRowCounts[table] || 0) && (
            <div className="text-center mt-4">
              <button
                className="view-more-btn"
                onClick={() => navigate("/supplier")}
              >
                View More
              </button>
            </div>
          )}
        </div>
      ))} */}
      {/* ALL SUPPLIERS IN ONE ROW */}
      <div className="container-section mb-5">
        <h2 className="section-title mb-0">Materials</h2>

        <GridRow
          items={Object.values(groupedSuppliers).flat()}
          onCountChange={setSupplierRowCounts}
          renderCard={(item) => (
            <SupplierCard
              key={`${item.supplier_table}-${item.id}`}
              item={item}
              openImagePopup={openImagePopup}
              handleLocationRedirect={handleLocationRedirect}
            />
          )}
        />

        {Object.values(groupedSuppliers).flat().length >
          (supplierRowCounts || 0) && (
          <div className="text-center mt-4">
            <button
              className="view-more-btn"
              onClick={() => navigate("/supplier")}
            >
              View More
            </button>
          </div>
        )}
      </div>
      {showAdModal && (
        <div className="dlm-overlay" onClick={() => setShowAdModal(false)}>
          <div className="dlm-dialog" onClick={(e) => e.stopPropagation()}>
            <div className="dlm-content">
              {/* Header */}
              <div className="dlm-header">
                <h2 className="dlm-title">Unlocking Your Design</h2>
                <p className="dlm-subtitle">
                  We provide 100% free designs thanks to our sponsors.
                </p>
              </div>

              {/* Sponsored Card */}
              <div className="dlm-ad-card">
                <div className="dlm-ad-badge">SPONSORED AD</div>
                <div className="dlm-ad-body">
                  <h4 className="dlm-ad-brand">Your Ad Space Here</h4>
                  <div className="dlm-ad-placeholder">
                    <AdsSquare />
                  </div>
                </div>
              </div>

              {/* Dynamic Action Section */}
              <div className="dlm-action-section">
                {adTimer > 0 ? (
                  <div className="dlm-timer-wrapper">
                    <span className="dlm-timer-text">
                      Preparing your file...
                    </span>
                    <div className="dlm-timer-number">{adTimer}s</div>
                  </div>
                ) : (
                  <div className="dlm-ready-area">
                    <p className="dlm-ready-msg">✨ Your file is ready!</p>
                    <a
                      href={pendingDownloadUrl?.url || "#"}
                      className="dlm-btn-download"
                      onClick={(e) => {
                        e.preventDefault();

                        const url = pendingDownloadUrl?.url;
                        const code = pendingDownloadUrl?.code || "design";
                        const id = pendingDownloadUrl?.id;

                        if (!url) return;

                        let ext = "emb";
                        if (url.includes(".zip")) ext = "zip";
                        else if (url.includes(".rar")) ext = "rar";

                        const link = document.createElement("a");
                        link.href = url;
                        link.download = `${code}.${ext}`;

                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);

                        if (id) {
                          setDownloaded((prev) => ({
                            ...prev,
                            [id]: true,
                          }));
                        }

                        setShowAdModal(false);
                      }}
                    >
                      Download Now
                    </a>
                  </div>
                )}
              </div>

              {/* Secondary Dismiss Action */}
              <button
                type="button"
                className="dlm-btn-dismiss"
                onClick={() => setShowAdModal(false)}
              >
                Maybe later
              </button>
            </div>
          </div>
        </div>
      )}

      {popupData.open && (
        <div
          className="image-popup"
          onClick={() => setPopupData((p) => ({ ...p, open: false }))}
        >
          <div
            className="image-popup-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="popup-close"
              onClick={() => setPopupData((p) => ({ ...p, open: false }))}
            >
              ✕
            </button>

            <img
              src={`${API.BASE_URL}/uploads/${popupData.folder}/${popupData.userId}/${popupData.images[popupData.index]}`}
              alt=""
            />

            <button
              className="popup-nav left"
              onClick={() =>
                setPopupData((p) => ({
                  ...p,
                  index: Math.max(0, p.index - 1),
                }))
              }
            >
              <i className="bi bi-chevron-left"></i>
            </button>

            <button
              className="popup-nav right"
              onClick={() =>
                setPopupData((p) => ({
                  ...p,
                  index: Math.min(p.images.length - 1, p.index + 1),
                }))
              }
            >
              <i className="bi bi-chevron-right"></i>
            </button>
          </div>
        </div>
      )}
      {/* Full Screen Image Lightbox Modal with Slider */}
      {lightboxData && (
        <div
          className="eb-image-modal-backdrop"
          onClick={() => setLightboxData(null)}
        >
          <div
            className="eb-image-modal-container"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              type="button"
              className="eb-image-modal-close"
              onClick={() => setLightboxData(null)}
              title="Close (Esc)"
            >
              &times;
            </button>

            {/* Slider Image */}
            <img
              src={lightboxData.images[lightboxData.currentIndex]}
              alt={`Expanded Preview ${lightboxData.currentIndex + 1}`}
              className="eb-image-modal-src"
            />

            {/* Previous & Next Navigation Buttons */}
            {lightboxData.images.length > 1 && (
              <>
                <button
                  type="button"
                  className="eb-lightbox-nav eb-lightbox-prev"
                  onClick={handlePrevImage}
                  title="Previous Image (Left Arrow)"
                >
                  <i className="bi bi-chevron-left"></i>
                </button>

                <button
                  type="button"
                  className="eb-lightbox-nav eb-lightbox-next"
                  onClick={handleNextImage}
                  title="Next Image (Right Arrow)"
                >
                  <i className="bi bi-chevron-right"></i>
                </button>

                {/* Counter Tag */}
                <div className="eb-lightbox-counter">
                  {lightboxData.currentIndex + 1} / {lightboxData.images.length}
                </div>
              </>
            )}
          </div>
        </div>
      )}
      {selectedWork && (
        <div
          className="eb-modal-backdrop"
          onClick={() => setSelectedWork(null)}
        >
          <div className="eb-modal-card" onClick={(e) => e.stopPropagation()}>
            <div className="eb-modal-header">
              <h5>Add Bids Option</h5>
              <button
                className="eb-modal-close-btn"
                onClick={() => setSelectedWork(null)}
              >
                &times;
              </button>
            </div>
            <form onSubmit={handleConfirmAddBeads}>
              <div className="eb-modal-body">
                <p className="eb-modal-desc">
                  Specify your quote for this work request.
                </p>

                <div className="eb-input-group">
                  <label>Bid Price (₹)</label>

                  <input
                    type="number"
                    min="1"
                    step="any"
                    placeholder="Enter your bid"
                    value={priceInput}
                    onChange={(e) => setPriceInput(e.target.value)}
                    required
                  />
                </div>

                <div
                  style={{
                    marginTop: 20,
                    background: "#f8f9fa",
                    border: "1px solid #ddd",
                    borderRadius: 8,
                    padding: 15,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: 8,
                    }}
                  >
                    <span>Your Bid</span>
                    <strong>₹ {bidPrice.toFixed(2)}</strong>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: 8,
                      color: "#dc3545",
                    }}
                  >
                    <span>Platform Commission ({commission}%)</span>
                    <strong>- ₹ {commissionAmount.toFixed(2)}</strong>
                  </div>

                  <hr />

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: 18,
                    }}
                  >
                    <span>You Will Receive</span>
                    <strong style={{ color: "#198754" }}>
                      ₹ {finalAmount.toFixed(2)}
                    </strong>
                  </div>
                </div>
              </div>
              <div className="eb-modal-footer">
                <button
                  type="button"
                  className="eb-btn-secondary"
                  onClick={() => setSelectedWork(null)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="eb-btn-primary"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "Confirm & Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {showDescriptionModal && (
        <div
          className="eb-modal-backdrop"
          onClick={() => setShowDescriptionModal(false)}
        >
          <div
            className="eb-modal-card"
            style={{ maxWidth: "700px" }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="eb-modal-header">
              <h5>Work Description</h5>

              <button
                className="eb-modal-close-btn"
                onClick={() => setShowDescriptionModal(false)}
              >
                &times;
              </button>
            </div>

            <div className="eb-modal-body">
              <p
                style={{
                  whiteSpace: "pre-wrap",
                  lineHeight: "1.8",
                  fontSize: "15px",
                }}
              >
                {selectedDescription}
              </p>
            </div>

            <div className="eb-modal-footer">
              <button
                className="eb-btn-secondary"
                onClick={() => setShowDescriptionModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      {showProfile && (
        <Profile isOpen={showProfile} onClose={() => setShowProfile(false)} />
      )}

      <Login
        isOpen={showLogin}
        onClose={() => setShowLogin(false)}
        openRegister={() => {
          setShowLogin(false);

          navigate("/register", {
            state: { from: "/" }, // Home page
          });
        }}
      />
      <style>{`
        .btn-teal { background-color: #11867f; color: white; border: none; padding: 10px; width:100%;}
        
.btn-teal1 { background-color: #146862; color: white; border: none; padding: 10px; width:100%;}
        .design-img-box { overflow: hidden; position: relative; background: #f8f9fa; }
        
        /* BILLARY MIRROR (Zoom Lens) CSS */
    

        .object-fit-contain { object-fit: contain; }



/* Modal Box */
.custom-modal-content {
  background: #ffffff;
  width: 90%;
  max-width: 450px;
  border-radius: 24px;
  padding: 40px;
  text-align: center;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.2);
  position: relative;
  margin-left:16px;
}

.modal-title {
  font-weight: 800;
  color: #1e293b;
  margin-bottom: 8px;
  font-size: 1.5rem;
}

/* Ad Container Styling */
.ad-card {
  background: #f8fafc;
  border: 2px dashed #cbd5e1;
  border-radius: 16px;
  padding: 20px;
  margin: 25px 0;
  position: relative;
}

.ad-badge {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  background: #10334b;
  color: white;
  font-size: 10px;
  font-weight: bold;
  padding: 4px 12px;
  border-radius: 20px;
  letter-spacing: 1px;
}

.ad-brand {
  color: #132e4d;
  font-weight: 700;
  margin-top: 10px;
}

/* Timer Styling */
.timer-number {
  font-size: 2.5rem;
  font-weight: 800;
  color: #ef4444;
  margin-top: 10px;
}

/* Pulsing Loader Animation */
.pulse-loader {
  width: 40px;
  height: 40px;
  border: 4px solid #e2e8f0;
  border-top: 4px solid #2e4563;
  border-radius: 50%;
  margin: 15px auto;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Glow Download Button */
.btn-download-glow {
  display: inline-block;
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
  color: white;
  text-decoration: none;
  padding: 15px 30px;
  border-radius: 12px;
  font-weight: bold;
  font-size: 1.1rem;
  width: 100%;
  box-shadow: 0 10px 15px -3px rgba(34, 197, 94, 0.4);
  transition: transform 0.2s ease;
}

.btn-download-glow:hover {
  transform: translateY(-2px);
  color: white;
}

.btn-close-modal {
  background: none;
  border: none;
  color: #94a3b8;
  margin-top: 20px;
  cursor: pointer;
  font-size: 0.9rem;
  text-decoration: underline;
}
      `}</style>
    </>
  );
}
